export default __webpack_public_path__ + "static/media/terminoliesIconDark.82a9e628.svg";